/* eslint-disable indent */
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import axios from 'axios'
import Dropdown from 'react-bootstrap/Dropdown'
import banneri from '../banneri.png'
import chppLogo from '../chpp.svg'
import Image from 'react-bootstrap/Image'
import { getTranslation } from '../services/translations'
import { hasFinnishStaffAccess, hasTeamSpiritAccess, isU21NationalTeam } from '../services/security'
import { setActiveNationalTeam } from '../reducers/userReducer'
import { resetPlayers } from '../reducers/playerReducer'
import { clearAllCandidates } from '../reducers/candidateReducer'
import { clearAllLists } from '../reducers/listReducer'
import { resetAllPlayers } from '../reducers/allPlayersReducer'
import { resetFilter } from '../reducers/filterReducer'
//import NavDropdown from 'react-bootstrap/NavDropdown';

const Menu = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)
  const location = useLocation()
  const [expanded, setExpanded] = useState(false)
  const lang = (user && user.language) || 'fi'
  const t = key => getTranslation(lang, key)
  const hasFinnishStaff = hasFinnishStaffAccess(user)
  const hasTeamSpiritNationalTeam = hasTeamSpiritAccess(user, false)
  const hasTeamSpiritU21 = hasTeamSpiritAccess(user, true)

  useEffect(() => {
    setExpanded(false)
  }, [location.pathname])

  // Hae aktiivisen maan nimi
  const getActiveNationName = () => {
    if (!user || !user.staff || !user.activeNationalTeam) return null
    const activeStaff = user.staff.find(
      s => s.nationalTeamId === user.activeNationalTeam
    )
    return activeStaff ? activeStaff.nationalTeamName : null
  }

  const welcome = () => {
    if (!user || !user.loginName) return ''
    const activeNation = getActiveNationName()
    if (activeNation) {
      return `${user.loginName} | ${activeNation}`
    }
    return user.loginName
  }

  const handleNationalTeamChange = async nationalTeamId => {
    if (
      !user?.oauth_token ||
      Number(nationalTeamId) === Number(user.activeNationalTeam)
    ) return

    try {
      await axios.put(`/users/active-team/${user.oauth_token}`, {
        nationalTeamId,
      })
      dispatch(setActiveNationalTeam(nationalTeamId))
      dispatch(resetPlayers())
      dispatch(clearAllCandidates())
      dispatch(clearAllLists())
      dispatch(resetAllPlayers())
      dispatch(resetFilter())
    } catch (error) {
      console.error('Error changing national team:', error)
    }
  }

  // Tarkista onko käyttäjällä pääsy rajoitettuihin välilehtiin
  // Joko uusi Staff-rooli tai NationalTeams-tietokenttä
  const hasNationalTeamAccess = () => {
    if (!user) return false
    // Uusi Staff-rooli
    if (user.staff && user.staff.length > 0) return true
    // NationalTeams-tietokenttä (CHPP:stä)
    if (user.NationalTeams && user.NationalTeams.NationalTeam) return true
    return false
  }

  const createLinkStyle = color => ({
    color: color,
    borderBottom: '3px solid transparent',
    paddingBottom: '0.5rem',
    transition: 'all 0.3s ease',
  })

  const createHoverHandler = color => e => {
    e.target.style.borderBottomColor = color
  }

  const handleMouseLeave = e => {
    e.target.style.borderBottomColor = 'transparent'
  }

  const handleNavLinkClick = () => {
    setExpanded(false)
  }

  // Väri kaikille linkeille
  const linkColor = '#43B581' // oranssi

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={nextExpanded => setExpanded(nextExpanded)}
      data-bs-theme="dark"
      style={{
        backgroundColor: '#2C2F33',
        borderColor: '#FFFFFF',
      }}
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Container>
          <Container
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Navbar.Brand>
              <img src={banneri} alt="banner" style={{ height: '40px' }} />
            </Navbar.Brand>
            <Navbar.Collapse className="justify-content-end">
              <Navbar.Brand>
                <a
                  href={
                    'https://hattrick.org/goto.ashx?path=/Community/CHPP/ChppProgramDetails.aspx?ApplicationId=5177'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    src={chppLogo}
                    width={70}
                    height={70}
                    alt="CHPP Logo"
                  />
                </a>
              </Navbar.Brand>
            </Navbar.Collapse>
          </Container>
          <Nav className="mr-auto">
            {user && user.oauth_token ? (
              <>
                <Nav.Link
                  as={Link}
                  to="/myplayers"
                  onClick={handleNavLinkClick}
                  style={createLinkStyle(linkColor)}
                  onMouseEnter={createHoverHandler(linkColor)}
                  onMouseLeave={handleMouseLeave}
                >
                  {t('myPlayers')}
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/simulator"
                  onClick={handleNavLinkClick}
                  style={createLinkStyle(linkColor)}
                  onMouseEnter={createHoverHandler(linkColor)}
                  onMouseLeave={handleMouseLeave}
                >
                  {t('simulator')}
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/skilldistribution"
                  onClick={handleNavLinkClick}
                  style={createLinkStyle(linkColor)}
                  onMouseEnter={createHoverHandler(linkColor)}
                  onMouseLeave={handleMouseLeave}
                >
                  {t('skills')}
                </Nav.Link>
                {hasNationalTeamAccess() ? (
                  <>
                    <Nav.Link
                      as={Link}
                      to="/allplayers"
                      onClick={handleNavLinkClick}
                      style={createLinkStyle(linkColor)}
                      onMouseEnter={createHoverHandler(linkColor)}
                      onMouseLeave={handleMouseLeave}
                    >
                      {t('allPlayers')}
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/lists"
                      onClick={handleNavLinkClick}
                      style={createLinkStyle(linkColor)}
                      onMouseEnter={createHoverHandler(linkColor)}
                      onMouseLeave={handleMouseLeave}
                    >
                      {t('lists')}
                    </Nav.Link>
                    {hasFinnishStaff ? (
                      <>
                        <Nav.Link
                          as={Link}
                          to="/teamtraining"
                          onClick={handleNavLinkClick}
                          style={createLinkStyle(linkColor)}
                          onMouseEnter={createHoverHandler(linkColor)}
                          onMouseLeave={handleMouseLeave}
                        >
                          {t('training')}
                        </Nav.Link>
                        <Nav.Link
                          as={Link}
                          to="/transfers"
                          onClick={handleNavLinkClick}
                          style={createLinkStyle(linkColor)}
                          onMouseEnter={createHoverHandler(linkColor)}
                          onMouseLeave={handleMouseLeave}
                        >
                          {t('transfers')}
                        </Nav.Link>
                      </>
                    ) : null}
                    {hasTeamSpiritNationalTeam ? <Nav.Link
                      as={Link}
                      to="/teamspirit"
                      onClick={handleNavLinkClick}
                      style={createLinkStyle(linkColor)}
                      onMouseEnter={createHoverHandler(linkColor)}
                      onMouseLeave={handleMouseLeave}
                    >
                      JH NT
                    </Nav.Link> : null}
                    {hasTeamSpiritU21 ? <Nav.Link
                      as={Link}
                      to="/teamspirit-u21"
                      onClick={handleNavLinkClick}
                      style={createLinkStyle(linkColor)}
                      onMouseEnter={createHoverHandler(linkColor)}
                      onMouseLeave={handleMouseLeave}
                    >
                      JH U21
                    </Nav.Link> : null}
                    {user?.loginName === 'Mizi91' ? <Nav.Link
                      as={Link}
                      to="/reports"
                      onClick={handleNavLinkClick}
                      style={createLinkStyle(linkColor)}
                      onMouseEnter={createHoverHandler(linkColor)}
                      onMouseLeave={handleMouseLeave}
                    >
                      Raportit
                    </Nav.Link> : null}
                  </>
                ) : (
                  <></>
                )}
                <Nav.Link
                  as={Link}
                  to="/achievements"
                  onClick={handleNavLinkClick}
                  style={createLinkStyle(linkColor)}
                  onMouseEnter={createHoverHandler(linkColor)}
                  onMouseLeave={handleMouseLeave}
                >
                  {t('achievements')}
                </Nav.Link>
              </>
            ) : (
              ''
            )}
            {user?.oauth_token ? (
              <Nav.Link
                as={Link}
                to="/"
                onClick={handleNavLinkClick}
                style={createLinkStyle(linkColor)}
                onMouseEnter={createHoverHandler(linkColor)}
                onMouseLeave={handleMouseLeave}
              >
                {t('myPage')}
              </Nav.Link>
            ) : null}
            <Navbar.Collapse className="justify-content-end">
              <Navbar.Text style={{ color: '#FFFFFF' }}>
                {getActiveNationName() ? <>
                  {user.loginName}
                  {' | '}
                  <Dropdown as="span">
                    <Dropdown.Toggle
                      as="button"
                      id="active-national-team-selector"
                      style={{
                        background: 'none',
                        border: 0,
                        color: '#FFFFFF',
                        padding: 0,
                        textDecoration: 'underline',
                      }}
                    >
                      {getActiveNationName()}
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      {(user.staff || [])
                        .filter(staff => !isU21NationalTeam(staff.nationalTeamName))
                        .map(staff => (
                        <Dropdown.Item
                          active={
                            Number(staff.nationalTeamId) ===
                            Number(user.activeNationalTeam)
                          }
                          key={staff.nationalTeamId}
                          onClick={() =>
                            handleNationalTeamChange(staff.nationalTeamId)
                          }
                        >
                          {staff.nationalTeamName}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </> : welcome()}
              </Navbar.Text>
            </Navbar.Collapse>
          </Nav>
        </Container>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default Menu
